import React, { useState } from 'react';
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js';
import { Doughnut } from 'react-chartjs-2';
import {
  brown,
  cyan,
  deepPurple,
  green,
  indigo,
  red,
  yellow,
} from '@mui/material/colors';
import { alpha } from '@mui/material';
import { useUpdateEffect } from 'react-use';

ChartJS.register(ArcElement, Tooltip, Legend);

const COLORS = {
  sad: indigo.A700,
  neutral: brown.A200,
  happy: yellow.A700,
  fearful: green[900],
  angry: red.A700,
  surprised: cyan.A700,
  disgusted: deepPurple.A700,
};

const DoughnutChart = ({ textColor, data10 }) => {
  const [data, setData] = useState({
    labels: [],
    datasets: [],
  });

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: 'right',
        align: 'left',
        labels: {
          color: textColor,
          boxWidth: 16,
          boxHeight: 16,
          padding: 8,
        },
      },
    },
  };

  useUpdateEffect(() => {
    if (data10) {
      const { labels, colors, data: ds } = data10;
      const backgroundColor = colors.map((v) => alpha(COLORS[v], 0.7));
      const hoverBackgroundColor = colors.map((v) => COLORS[v]);
      const datasets = [
        {
          data: ds,
          backgroundColor,
          hoverBackgroundColor,
          borderWidth: 1,
          hoverOffset: 4,
        },
      ];
      setData({ labels, datasets });
    }
  }, [data10]);

  return (
    <Doughnut
      data={data}
      options={options}
      onMouseDown={(e) => e.stopPropagation()}
    />
  );
};
export default DoughnutChart;
